import { IHeadlineProperties } from '@vfde-brix/ws10/headline';
import { getCMSConfig } from '../cms';

/**
 * Get the properties for the offer summary card headline component
 * @param {string} routerName - The selected router's name
 * @param {boolean} isContentEnabled - Whether any routers are available or not
 * @returns {Partial<IHeadlineProperties>} The properties to update on the headline component
 */
export const getOfferSummaryCardHeadlineProps = (
    routerName: string,
    isContentEnabled: boolean
): Partial<IHeadlineProperties> => ({
    stdContent: isContentEnabled
        ? `${routerName}<sup class="ws10-footnote-link-style">1</sup>`
        : getCMSConfig().offerSummaryCard.notAvailable.headline,
});
